import { icons } from "assets";
import Button from "Components/shared/button";
import FormControl from "Components/shared/control";
import { InputWithAdornment } from "Components/shared/inputs";
import Text from "Components/shared/text";
import React from "react";
import styles from "./registeration.module.css";

const StageOne = ({
  onNext,
  onPrev,
  values = {},
  errors = {},
  handleChange=() => {},
  touched = {},
  handleUpdate = () => {}
}) => {
  
  return (
    <div className={styles.StageOne}>
      <Text className={styles.Text} variant="xl" color="primary">
        Lets get your email address
      </Text>
      <FormControl
        label="First, enter your full name"
        
        style={{ marginTop: "25px" }}
        
        fullWidth={true}
      >
        <div className="w-full row-start">
          <InputWithAdornment
            right={<img src={icons.ic_human} alt="mail icon" />}
            fullWidth
            placeholder="Enter your full name"
            name="fullName"
            id="fullName"
            value={values.fullName}
            error={errors.fullName && touched.fullName && errors.fullName}
            {... handleUpdate()}
          />
        </div>
      </FormControl>
      <FormControl
        label="Enter your email address"
        
        style={{ marginTop: "25px" }}
        
        fullWidth={true}
      >
        <div className="w-full row-start">
          <InputWithAdornment
            right={<img src={icons.envelope} alt="mail icon" />}
            type="email"
            name="email"
            id="email"
            fullWidth
            placeholder="Enter your email"
            value={values.email}
            error={errors.email && touched.email && errors.email}
            {...handleUpdate()}
          />
        </div>
      </FormControl>
      <FormControl fullWidth>
        <Button fullWidth label="Next" onClick={onNext} 
        disabled={!!(errors.email || errors.fullName)} />
      </FormControl>
    </div>
  );
};

export default StageOne;
